import FilterPanel from "components/partials/filter-panel/filter-panel";
import ColumnOptions from "components/partials/column-options/column-options";

import { TouchpointType } from "types/touchpoint";
import { FiltersListProps, FiltersStateOnTable } from "types/filters";
import { UserTableLayout } from "hooks/api/use-user-layout";
import { ColumnOption } from "types/table";

const filtersToDisplay: FiltersListProps[] = [
  {
    title: "Template type",
    filterId: "type",
    options: [
      { name: TouchpointType.EMAIL, description: "Email" },
      { name: TouchpointType.LANDING_PAGE, description: "Web page" },
      { name: TouchpointType.OTHER, description: "Other" },
    ],
  },
];

interface FiltersOnProgramTemplatesTableProps extends FiltersStateOnTable {
  tableColumnsConfig: UserTableLayout;
  columnOptions: ColumnOption[];
  onToggleColumn: (columnId: string) => void;
  isFetching?: boolean;
}

const FiltersOnProgramTemplatesTable = ({
  filtersToApply,
  setFiltersToApply,
  tableColumnsConfig,
  columnOptions,
  onToggleColumn,
  isFetching = false,
}: FiltersOnProgramTemplatesTableProps) => {
  const handleFilterChange = (filter: { filterId: string }, option: { name: string }) => {
    const filterKey = filter.filterId as keyof typeof filtersToApply;
    const currentValues = (filtersToApply[filterKey] as string[]) || [];
    const isSelected = currentValues.includes(option.name);

    setFiltersToApply({
      ...filtersToApply,
      [filterKey]: isSelected
        ? currentValues.filter((item) => item !== option.name)
        : [...currentValues, option.name],
    });
  };

  return (
    <>
      <FilterPanel
        filters={filtersToDisplay}
        currentFilters={filtersToApply}
        onFilterChange={handleFilterChange}
        isFetching={isFetching}
      />

      <ColumnOptions
        tableConfigKey="programTemplates"
        tableColumnsConfig={tableColumnsConfig}
        columnOptions={columnOptions}
        onToggleColumn={onToggleColumn}
      />
    </>
  );
};

export default FiltersOnProgramTemplatesTable;
